import { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../lib/i18next";
import Button from "../../../components/Buttons/Button";
import {
  AI_COMPETITORS_ERROR_INVALID_URL,
  AI_COMPETITORS_ERROR_NO_COMPETITORS,
  AI_COMPETITORS_OUTLINED_INPUT_SX,
} from "../aiCompetitorsConstants";
import {
  AI_COMPETITORS_URL_BLOCKED,
  AI_COMPETITORS_URL_CTA,
  AI_COMPETITORS_URL_DESCRIPTION,
  AI_COMPETITORS_URL_INVALID,
  AI_COMPETITORS_URL_MUTED,
  AI_COMPETITORS_URL_NO_COMPETITORS,
  AI_COMPETITORS_URL_PLACEHOLDER,
  AI_COMPETITORS_URL_STEP_NUMBER,
  AI_COMPETITORS_URL_TITLE,
} from "../../../i18n/keysTranslations";
import { looksLikeDomain } from "../aiCompetitorsUrl";
import AiCompetitorsStepIntro from "./AiCompetitorsStepIntro";

const getUrlErrorMessage = (localError, errorCode, t) => {
  if (localError || errorCode === AI_COMPETITORS_ERROR_INVALID_URL) {
    return t(AI_COMPETITORS_URL_INVALID);
  }
  if (errorCode === AI_COMPETITORS_ERROR_NO_COMPETITORS) {
    return t(AI_COMPETITORS_URL_NO_COMPETITORS);
  }
  if (errorCode) {
    return t(AI_COMPETITORS_URL_BLOCKED);
  }
  return "";
};

const AiCompetitorsUrlStep = ({ onSubmit, errorCode, initialUrl = "" }) => {
  const { t } = useTranslationApp();
  const [websiteUrl, setWebsiteUrl] = useState(initialUrl);
  const [localError, setLocalError] = useState("");

  const onContinue = () => {
    const nextUrl = websiteUrl.trim();
    if (!looksLikeDomain(nextUrl)) {
      setLocalError(AI_COMPETITORS_URL_INVALID);
      return;
    }
    setLocalError("");
    onSubmit(nextUrl);
  };

  const errorMessage = getUrlErrorMessage(localError, errorCode, t);

  return (
    <Box>
      <AiCompetitorsStepIntro
        stepNumber={t(AI_COMPETITORS_URL_STEP_NUMBER)}
        title={t(AI_COMPETITORS_URL_TITLE)}
        mutedTitle={t(AI_COMPETITORS_URL_MUTED)}
        description={t(AI_COMPETITORS_URL_DESCRIPTION)}
      />
      <Box
        sx={{
          mt: { xs: 3, sm: 5 },
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <TextField
          value={websiteUrl}
          onChange={(event) => {
            setWebsiteUrl(event.target.value);
            if (localError) setLocalError("");
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              onContinue();
            }
          }}
          placeholder={t(AI_COMPETITORS_URL_PLACEHOLDER)}
          variant="outlined"
          fullWidth
          autoFocus
          error={Boolean(errorMessage)}
          sx={AI_COMPETITORS_OUTLINED_INPUT_SX}
        />
        <Button
          color="primary"
          fullWidth
          onClick={onContinue}
          sx={{
            width: "100%",
            height: 48,
            whiteSpace: "normal",
            textTransform: "none",
          }}
        >
          {t(AI_COMPETITORS_URL_CTA)}
        </Button>
      </Box>
      {errorMessage ? (
        <Typography sx={{ mt: 1.5, fontSize: 12, color: "error.main", lineHeight: 1.5 }}>
          {errorMessage}
        </Typography>
      ) : null}
    </Box>
  );
};

export default AiCompetitorsUrlStep;
